import {UserSettingModel} from '../../model/users/UserSettingModel';
import {BaseCollection} from '../BaseCollection';

/**
 * @class UserSettingsCollection
 * @extends BaseCollection
 */
export class UserSettingsCollection extends BaseCollection {

    get model () {

        return UserSettingModel;
    }

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'users';
        this.resource = 'settings';


    }

    /**
     * @description Will try to find setting by scope and name.
     *
     * @param {string} scope
     * @param {string} name
     *
     * @return {UserSettingModel|null}
     */
    getSetting (scope, name) {

        let found = this.find((setting) => (setting.get('scope') === scope
                                            && setting.get('name') === name));

        return (typeof found !== 'undefined' ? found : null);
    }

    /**
     * @description Will set and save user setting.
     *
     * @param {string} scope
     * @param {string} name
     * @param {mixed}  value
     * @param {boolean} [saveSetting = true]
     *
     * @return {promise}
     */
    setSetting (scope, name, value, saveSetting = true) {

        let setting = this.getSetting(scope, name);

        if (setting !== null) {

            setting.set('value', value);
        }
        else {

            setting = new UserSettingModel({
                'scope': scope,
                'name': name,
                'value': value
            });

            this.add(setting);
        }

        if (saveSetting && setting.get('value')) {
            return setting.save();
        } else {
            return $.Deferred().resolve();
        }
    }

    /**
     * @description Will check if setting exists based on the scope and name.
     *
     * @param {string} scope
     * @param {string} name
     *
     * @return {boolean}
     */
    checkIfSettingExists (scope, name) {

        return !!this.getSetting(scope, name);
    }
}



// WEBPACK FOOTER //
// ./shared/collection/users/UserSettingsCollection.js